import { auth, authAll } from '@/util'
const data = ['.*#<', -0.1314502, -1314502]

export default function directive(app) {
    // 注册 v-auth 和 v-auth-all 指令
    app.directive('auth', {
        mounted: (el, binding) => {
            if (!auth(binding.value)) {
                el.remove()
            }
        }
    })
    app.directive('auth-all', {
        mounted: (el, binding) => {
            if (!authAll(binding.value)) {
                el.remove()
            }
        }
    })
    app.directive('filter-blur', {
        mounted: (el, binding) => {
            // console.log(el, binding.value, 'gggg')
            // el.classname = 'filterBlur'
            // if (data) {

            // }
            if (data.includes(binding.value)) {
                el.classList.add('filterBlur')
            }
        },
        updated: (el, binding) => {
            // console.log(el, binding.value)
            if (data.includes(binding.value)) {
                el.classList.add('filterBlur')
            }
        }
    })
    // app.directive('click-outside', {
    //     mounted(el, binding) {
    //         function eventHandler(e) {
    //             if (el.contains(e.target)) {
    //                 return false
    //             }
    //             // 如果绑定的参数是函数，正常情况也应该是函数，执行
    //             if (binding.value && typeof binding.value === 'function') {
    //                 binding.value(e)
    //             }
    //         }
    //         // 用于销毁前注销事件监听
    //         el.__click_outside__ = eventHandler
    //         // 添加事件监听
    //         document.addEventListener('click', eventHandler)
    //     },
    //     beforeUnmount(el) {
    //         // 移除事件监听
    //         document.removeEventListener('click', el.__click_outside__)
    //         // 删除无用属性
    //         delete el.__click_outside__
    //     }
    // })
}
